// Start:: Importing Middleware
import auth from "../middleware/auth.js";
import Authentication from "../pages/Authentication.vue";
// End:: Importing Middleware

// Start:: Importing Router Components
import Vue from "vue";
import VueRouter from "vue-router";
// End:: Importing Router Components

// ============== Start:: Home Page Route
import AppContentWrapper from "../pages/AppContentWrapper.vue";
import HomePage from "../pages/HomePage.vue";
// ============== End:: Home Page Route

// ============== Start:: Roles Routes
import RolesHome from "../views/Cruds/Roles/Home.vue";
import AllRoles from "../views/Cruds/Roles/ShowAll.vue";
import EditRole from "../views/Cruds/Roles/Edit.vue";
import CreateRole from "../views/Cruds/Roles/Create.vue";
// ============== End:: Roles Routes

// // ============== Start:: Financial Reports Routes
// import FinancialReportsHome from "../views/Cruds/FinancialReports/Home.vue";
// import AllFinancialReports from "../views/Cruds/FinancialReports/ShowAll.vue";
// import ShowFinancialReport from "../views/Cruds/FinancialReports/Show.vue";
// // ============== End:: Financial Reports Routes

// // ============== Start:: FinancialfinshedReports Routes
// import FinancialFinshedReportsHome from "../views/Cruds/FinancialFinshedReports/Home.vue";
// import AllFinancialFinshedReports from "../views/Cruds/FinancialFinshedReports/ShowAll.vue";
// import ShowFinancialFinshedReport from "../views/Cruds/FinancialFinshedReports/Show.vue";
// // ============== End:: FinancialfinshedReports Routes

// ============== Start:: FinancialFinshedOrders Routes
import FinancialFinishedOrdersHome from "../views/Cruds/FinancialFinishedOrders/Home.vue";
import AllFinancialFinishedOrders from "../views/Cruds/FinancialFinishedOrders/ShowAll.vue";
// ============== End:: FinancialOrders Routes
// ============== Start:: FinancialUnFinshedOrders Routes
import FinancialUnFinishedOrdersHome from "../views/Cruds/FinancialUnFinishedOrders/Home.vue";
import AllFinancialUnFinishedOrders from "../views/Cruds/FinancialUnFinishedOrders/ShowAll.vue";
// ============== End:: FinancialOrders Routes

// // ============== Start:: FinancialPack Routes
// import FinancialPackHome from "../views/Cruds/FinancialPack/Home.vue";
// import AllFinancialPack from "../views/Cruds/FinancialPack/ShowAll.vue";
// // // ============== End:: FinancialPack Routes

// ============== Start:: AppRates Routes
import AppRatesHome from "../views/Cruds/AppRates/Home.vue";
import AllAppRates from "../views/Cruds/AppRates/ShowAll.vue";
// ============== End:: AppRates Routes

// ============== Start:: StoreRates Routes
import StoreRatesHome from "../views/Cruds/StoreRates/Home.vue";
import AllStoreRates from "../views/Cruds/StoreRates/ShowAll.vue";
// ============== End:: StoreRates Routes

// ============== Start:: Admins Routes
import ShowAdmin from "../views/Cruds/Admins/Show.vue";
import EditAdmin from "../views/Cruds/Admins/Edit.vue";
import CreateAdmin from "../views/Cruds/Admins/Create.vue";
import AllAdmins from "../views/Cruds/Admins/ShowAll.vue";
import AdminsHome from "../views/Cruds/Admins/Home.vue";
// ============== End:: Admins Routes

// ============== Start:: login Routes
import LoginForm from "../views/Auth/LoginForm.vue";
import ResetPasswordEmailForm from "../views/Auth/ResetPasswordEmailForm.vue";
import EmailVerificationForm from "../views/Auth/EmailVerificationForm.vue";
import ChangePhoneNumberForm from "../views/Auth/ChangePhoneNumber.vue";
import ResetPasswordForm from "../views/Auth/ResetPasswordForm.vue";
// ============== End:: login Routes

// ============== Start:: Contact Messages Routes
import ContactMessagesHome from "../views/Cruds/ContactMessages/Home.vue";
import AllContactMessages from "../views/Cruds/ContactMessages/ShowAll.vue";
import showMessage from "../views/Cruds/ContactMessages/Show.vue";
// ============== End:: Contact Messages Routes


// ============== Start:: App Content Routes
import AppContentHome from "../views/Cruds/AppContent/Home.vue";
import AppSettings from "../views/Cruds/AppSettings/AppSettings.vue";
import GeneralSettings from "../views/Cruds/AppSettings/GeneralSettings.vue";
import ContactUsDriver from "../views/Cruds/AppContent/ContactUsDriver.vue";
import ContactUsClient from "../views/Cruds/AppContent/ContactUsClient.vue";
import ContactUsProvider from "../views/Cruds/AppContent/ContactUsProvider.vue";
import AboutUsClient from "../views/Cruds/AppContent/AboutUsClient.vue";
import AboutUsDriver from "../views/Cruds/AppContent/AboutUsDriver.vue";
import AboutUsProvider from "../views/Cruds/AppContent/AboutUsProvider.vue";
import TermsClient from "../views/Cruds/AppContent/TermsClient.vue";
import TermsProvider from "../views/Cruds/AppContent/TermsProvider.vue";
import TermsDriver from "../views/Cruds/AppContent/TermsDriver.vue";
import PrivacyPolicyClient from "../views/Cruds/AppContent/PrivacyPolicyClient.vue";
import PrivacyPolicyProvider from "../views/Cruds/AppContent/PrivacyPolicyProvider.vue";
import PrivacyPolicyDriver from "../views/Cruds/AppContent/PrivacyPolicyDriver.vue";
import DeleteAccount from "../views/Cruds/AppContent/DeleteAccount.vue";
// ============== End:: App Content Routes

// Start:: Questiions Router Components
import questionsHome from "../views/Cruds/FAQ/Home.vue";
import Allquestions from "../views/Cruds/FAQ/ShowAll.vue";
import Createquestions from "../views/Cruds/FAQ/Create.vue";
import Editquestions from "../views/Cruds/FAQ/Edit.vue";
// End:: Questions Router Components

// ============ Start:: Users Routes
import UsersHome from "../views/Cruds/Users/Home.vue";
import AllUsers from "../views/Cruds/Users/ShowAll.vue";
import ShowUsers from "../views/Cruds/Users/Show.vue";
// ============ End:: Users Routes

// ============== Start:: Ads Routes
import AdsHome from "../views/Cruds/Ads/Home.vue";
import AllAds from "../views/Cruds/Ads/ShowAll.vue";
import CreateAds from "../views/Cruds/Ads/Create.vue";
import ShowAds from "../views/Cruds/Ads/Show.vue";
import EditAds from "../views/Cruds/Ads/Edit.vue";
// ============== End:: Ads Routes

// ============== Start:: Products Routes
import ProductsHome from "../views/Cruds/Products/Home.vue";
import AllProducts from "../views/Cruds/Products/ShowAll.vue";
import CreateProducts from "../views/Cruds/Products/Create.vue";
import ShowProducts from "../views/Cruds/Products/Show.vue";
import EditProducts from "../views/Cruds/Products/Edit.vue";
// ============== End:: Products Routes

// ============== Start:: States Routes
import StatesHome from "../views/Cruds/States/Home.vue";
import AllStates from "../views/Cruds/States/ShowAll.vue";
import CreateStates from "../views/Cruds/States/Create.vue";
import ShowStates from "../views/Cruds/States/Show.vue";
import EditStates from "../views/Cruds/States/Edit.vue";
// ============== End:: States Routes

// ============== Start:: Districts Routes
import DistrictsHome from "../views/Cruds/Districts/Home.vue";
import AllDistricts from "../views/Cruds/Districts/ShowAll.vue";
import CreateDistricts from "../views/Cruds/Districts/Create.vue";
import ShowDistricts from "../views/Cruds/Districts/Show.vue";
import EditDistricts from "../views/Cruds/Districts/Edit.vue";
// ============== End:: Cities Routes

// ============== Start:: Regions Routes
import RegionsHome from "../views/Cruds/Regions/Home.vue";
import AllRegions from "../views/Cruds/Regions/ShowAll.vue";
import CreateRegions from "../views/Cruds/Regions/Create.vue";
import ShowRegions from "../views/Cruds/Regions/Show.vue";
import EditRegions from "../views/Cruds/Regions/Edit.vue";
// ============== End:: Regions Routes

// ============== Start:: Services Routes
import ServicesHome from "../views/Cruds/Services/Home.vue";
import AllServices from "../views/Cruds/Services/ShowAll.vue";
import CreateServices from "../views/Cruds/Services/Create.vue";
import ShowServices from "../views/Cruds/Services/Show.vue";
import EditServices from "../views/Cruds/Services/Edit.vue";
// ============== End:: Services Routes

// ============== Start:: Workplaces Routes
import WorkplacesHome from "../views/Cruds/Workplaces/Home.vue";
import AllWorkplaces from "../views/Cruds/Workplaces/ShowAll.vue";
import CreateWorkplaces from "../views/Cruds/Workplaces/Create.vue";
import ShowWorkplaces from "../views/Cruds/Workplaces/Show.vue";
import EditWorkplaces from "../views/Cruds/Workplaces/Edit.vue";
// ============== End:: Workplaces Routes

// ============== Start:: WalletRequests Routes
import RequestWalletsHome from "../views/Cruds/WalletRequests/Home.vue";
import AllRequestWallets from "../views/Cruds/WalletRequests/ShowAll.vue";
// ============== End:: WalletRequests Routes

// ============== Start:: WalletHistory Routes
import WalletHistoryHome from "../views/Cruds/WalletHistory/Home.vue";
import AllWalletHistory from "../views/Cruds/WalletHistory/ShowAll.vue";
// ============== End:: WalletRequests Routes

// ============== Start:: Reasons Routes
import ReasonsHome from "../views/Cruds/Reasons/Home.vue";
import AllReasons from "../views/Cruds/Reasons/ShowAll.vue";
import CreateReasons from "../views/Cruds/Reasons/Create.vue";
import ShowReasons from "../views/Cruds/Reasons/Show.vue";
import EditReasons from "../views/Cruds/Reasons/Edit.vue";
// ============== End:: Reasons Routes
// ============== Start:: CardsCategories Routes
import CardsCategoriesHome from "../views/Cruds/CardsCategories/Home.vue";
import AllCardsCategories from "../views/Cruds/CardsCategories/ShowAll.vue";
import CreateCardsCategories from "../views/Cruds/CardsCategories/Create.vue";
import ShowCardsCategories from "../views/Cruds/CardsCategories/Show.vue";
// ============== End:: CardsCategories Routes
// ============== Start:: Cards Routes
import CardsHome from "../views/Cruds/Cards/Home.vue";
import AllCards from "../views/Cruds/Cards/ShowAll.vue";

// ============== End:: Cards Routes
// ============== Start:: Banks Routes
import BanksHome from "../views/Cruds/Banks/Home.vue";
import AllBanks from "../views/Cruds/Banks/ShowAll.vue";
import CreateBanks from "../views/Cruds/Banks/Create.vue";
import ShowBanks from "../views/Cruds/Banks/Show.vue";
import EditBanks from "../views/Cruds/Banks/Edit.vue";
// ============== End:: Banks Routes

// ============== Start:: Packages Routes
import PackagesHome from "../views/Cruds/Packages/Home.vue";
import AllPackages from "../views/Cruds/Packages/ShowAll.vue";
import CreatePackages from "../views/Cruds/Packages/Create.vue";
import ShowPackages from "../views/Cruds/Packages/Show.vue";
import EditPackages from "../views/Cruds/Packages/Edit.vue";
// ============== End:: Cities Routes

// ============== Start:: orders Routes
import ordersHome from "../views/Cruds/Orders/Home.vue";
import Allorders from "../views/Cruds/Orders/ShowAll.vue";
import Showorders from "../views/Cruds/Orders/Show.vue";
// ============== End:: orders Routes

// ============== Start:: UserRequests Routes =================
import UserRequestsHome from "../views/Cruds/UserRequests/Home.vue";
import AllUserRequests from "../views/Cruds/UserRequests/ShowAll.vue";
import ShowUserRequests from "../views/Cruds/UserRequests/Show.vue";
// ============== Start:: UserRequests Routes =================
// ============== Start:: UserRequests Routes =================
import AdminsRequestsHome from "../views/Cruds/AdminsRequests/Home.vue";
import AllAdminsRequests from "../views/Cruds/AdminsRequests/ShowAll.vue";
import ShowAdminsRequests from "../views/Cruds/AdminsRequests/Show.vue";
import WalletProvider from "../views/Cruds/WalletProvider/ShowAll.vue";
import WalletDriver from "../views/Cruds/WalletDriver/ShowAll.vue";
// ============== Start:: UserRequests Routes =================
// ============== Start:: Accepted Providers Routes =================
import ProviderHome from "../views/Cruds/Providers/Home.vue";
import AllProviders from "../views/Cruds/Providers/ShowAll.vue";
import ShowProviders from "../views/Cruds/Providers/Show.vue";
import EditProviders from "../views/Cruds/Providers/Edit.vue";
import WorkingHoursProviders from "../views/Cruds/Providers/workingHours.vue";
// ============== Start:: Accepted Providers Routes =================
// ============== Start:: UserRequests Routes =================
import AdminsUpdateHome from "../views/Cruds/AdminsUpdate/Home.vue";
import AllAdminsUpdate from "../views/Cruds/AdminsUpdate/ShowAll.vue";
import ShowAdminsUpdate from "../views/Cruds/AdminsUpdate/Show.vue";
// ============== Start:: UserRequests Routes =================
// ============== Start:: UserRequests Routes =================
import DriverRequestsHome from "../views/Cruds/DriverRequests/Home.vue";
import AllDriverRequests from "../views/Cruds/DriverRequests/ShowAll.vue";
import ShowDriverRequests from "../views/Cruds/DriverRequests/Show.vue";
// ============== Start:: UserRequests Routes =================
// ============== Start:: UserRequests Routes =================
import DriverManegmentHome from "../views/Cruds/DriverManegment/Home.vue";
import AllDriverManegment from "../views/Cruds/DriverManegment/ShowAll.vue";
import ShowDriverManegment from "../views/Cruds/DriverManegment/Show.vue";
import EditDriverManegment from "../views/Cruds/DriverManegment/Edit.vue";
// ============== Start:: UserRequests Routes =================
// ============== Start:: UserRequests Routes =================
import DriverUpdateHome from "../views/Cruds/DriverUpdate/Home.vue";
import AllDriverUpdate from "../views/Cruds/DriverUpdate/ShowAll.vue";
import ShowDriverUpdate from "../views/Cruds/DriverUpdate/Show.vue";
// ============== Start:: UserRequests Routes =================

// ============== Start:: Providers Routes
// import ProvidersHome from "../views/Cruds/Providers/Home.vue";
// import AllProviders from "../views/Cruds/Providers/ShowAll.vue";
// import CreateProviders from "../views/Cruds/Providers/Create.vue";
// import ShowProviders from "../views/Cruds/Providers/Show.vue";
// import EditProviders from "../views/Cruds/Providers/Edit.vue";
// ============== End:: Providers Routes

// ============== Start:: All Notifications Routes
import AllNotifications from "../views/Cruds/Notifications/ShowAll.vue";
import NotificationsHome from "../views/Cruds/Notifications/Home.vue";
import CreateNotifications from "../views/Cruds/Notifications/Create.vue";
import ShowNotificationsTable from "../views/Cruds/Notifications/Show.vue";
// import ShowNotificationsIcon from "../views/Cruds/Notifications/Test.vue";
import ShowAllNotifications from "../views/Cruds/Notifications/ShowAllNotifications.vue";

// ============== End:: All Notifications Routes

// ================== Start:: Clients Routes
import ClientsHome from "../views/Cruds/Clients/Home.vue";
import AllClients from "../views/Cruds/Clients/ShowAll.vue";
import ShowClients from "../views/Cruds/Clients/Show.vue";
// ================= End:: Clients Routes

//=============== Start:: Order Desiginer Routes
import OrdersRequestsHome from "../views/Cruds/OrdersRequests/Home.vue";
import AllOrdersRequests from "../views/Cruds/OrdersRequests/ShowAll.vue";
import ShowOrdersRequests from "../views/Cruds/OrdersRequests/Show.vue";
//============== End:: Order Desiginer Routes

// ============== Start:: Product Categories Routes
import ProductCategoriesHome from "../views/Cruds/ProductCategories/Home.vue";
import AllProductCategories from "../views/Cruds/ProductCategories/ShowAll.vue";
import CreateProductCategories from "../views/Cruds/ProductCategories/Create.vue";
import EditProductCategories from "../views/Cruds/ProductCategories/Edit.vue";
import ShowProductCategories from "../views/Cruds/ProductCategories/Show.vue";
// ============== End:: Product Categories Routes

// ============== Start:: MainCategories Routes
import CategoriesHome from "../views/Cruds/MainCategories/Home.vue";
import AllCategories from "../views/Cruds/MainCategories/ShowAll.vue";
import CreateCategories from "../views/Cruds/MainCategories/Create.vue";
import EditCategories from "../views/Cruds/MainCategories/Edit.vue";
import ShowCategories from "../views/Cruds/MainCategories/Show.vue";
// ============== End:: MainCategories Routes

// ============== Start:: SubCategories Routes
import SubCategoriesHome from "../views/Cruds/SubCategories/Home.vue";
import AllSubCategories from "../views/Cruds/SubCategories/ShowAll.vue";
import CreateSubCategories from "../views/Cruds/SubCategories/Create.vue";
import EditSubCategories from "../views/Cruds/SubCategories/Edit.vue";
import ShowSubCategories from "../views/Cruds/SubCategories/Show.vue";
// ============== End:: SubCategories Routes

// ============== Start:: Sizes Routes
import AllSizes from "../views/Cruds/Sizes/ShowAll.vue";
import ShowSizes from "../views/Cruds/Sizes/Show.vue";
import EditSizes from "../views/Cruds/Sizes/Edit.vue";
import CreateSizes from "../views/Cruds/Sizes/Create.vue";
import SizesHome from "../views/Cruds/Sizes/Home.vue";
// ============== End:: Sizes Routes

// ============== Start:: Additions Routes
import AllAdditions from "../views/Cruds/Additions/ShowAll.vue";
import ShowAdditions from "../views/Cruds/Additions/Show.vue";
import EditAdditions from "../views/Cruds/Additions/Edit.vue";
import CreateAdditions from "../views/Cruds/Additions/Create.vue";
import AdditionsHome from "../views/Cruds/Additions/Home.vue";
// ============== End:: Additions Routes

// ============== Start:: Offers Routes
import AllOffers from "../views/Cruds/Offers/ShowAll.vue";
import ShowOffers from "../views/Cruds/Offers/Show.vue";
import EditOffers from "../views/Cruds/Offers/Edit.vue";
import CreateOffers from "../views/Cruds/Offers/Create.vue";
import OffersHome from "../views/Cruds/Offers/Home.vue";
// ============== End:: Offers Routes

// ============== Start:: Capacities Routes
import CapacitiesHome from "../views/Cruds/Capacities/Home.vue";
import AllCapacities from "../views/Cruds/Capacities/ShowAll.vue";
import CreateCapacities from "../views/Cruds/Capacities/Create.vue";
import ShowCapacities from "../views/Cruds/Capacities/Show.vue";
import EditCapacities from "../views/Cruds/Capacities/Edit.vue";
// ============== End:: Capacities Routes

// ============== Start:: ResidentialAdd Routes
import ResidentialAddHome from "../views/Cruds/ResidentialAdd/Home.vue";
import AllResidentialAdd from "../views/Cruds/ResidentialAdd/ShowAll.vue";
import CreateResidentialAdd from "../views/Cruds/ResidentialAdd/Create.vue";
import ShowResidentialAdd from "../views/Cruds/ResidentialAdd/Show.vue";
import EditResidentialAdd from "../views/Cruds/ResidentialAdd/Edit.vue";
// ============== End:: ResidentialAdd Routes

// ============== Start:: Managements Routes
import ManagementsHome from "../views/Cruds/Managements/Home.vue";
import AllManagements from "../views/Cruds/Managements/ShowAll.vue";
import CreateManagements from "../views/Cruds/Managements/Create.vue";
import EditManagements from "../views/Cruds/Managements/Edit.vue";
import ShowManagements from "../views/Cruds/Managements/Show.vue";
// ============== End:: Managements Routes

// ============== Start:: Forbidden Route
import ForbiddenPage from "../pages/ForbiddenPage.vue";
// ============== End:: Forbidden Route

// ============== Start:: Not Found Route
import NotFoundPage from "../pages/NotFound.vue";
// ============== End:: Not Found Route

// End:: Importing Router Components

Vue.use(VueRouter);
const routes = [
  // ***************** Start:: Auth Routes Config
  {
    path: "/",
    component: Authentication,
    children: [
      {
        path: "/",
        component: LoginForm,
        name: "LoginForm",
      },
      {
        path: "/reset-password-email",
        name: "ResetPasswordEmailForm",
        component: ResetPasswordEmailForm,
      },
      {
        path: "/email-verification/:verification_type",
        name: "EmailVerificationForm",
        component: EmailVerificationForm,
      },
      {
        path: "/chang-phone-number",
        name: "ChangePhoneNumberForm",
        component: ChangePhoneNumberForm,
      },
      {
        path: "/reset-password",
        name: "ResetPasswordForm",
        component: ResetPasswordForm,
      },
    ],
  },
  // ***************** End:: Auth Routes Config

  // ***************** Start:: Content Routes Config
  {
    path: "/home",
    component: AppContentWrapper,
    children: [
      // Start:: Home Route Config
      {
        path: "/home",
        component: HomePage,
        meta: {
          middleware: [auth],
        },
      },
      // End:: Home Route Config

      // Start:: Contact Messages Routes Config
      {
        path: "/contact-messages",
        name: "ContactMessagesHome",
        component: ContactMessagesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllContactMessages",
            component: AllContactMessages,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "contacts index",
                subject: "contacts",
              },
            },
          },
          {
            path: "show/:id",
            name: "showMessage",
            component: showMessage,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "contacts show",
                subject: "contacts",
              },
            },
          },
        ],
      },
      // End:: Contact Messages Routes Config

      // Start:: App Content Routes Config
      {
        path: "/app-content",
        name: "AppContentHome",
        component: AppContentHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "contact-us-client",
            name: "ContactUsClient",
            component: ContactUsClient,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "contact-us-driver",
            name: "ContactUsDriver",
            component: ContactUsDriver,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "contact-us-provider",
            name: "ContactUsProvider",
            component: ContactUsProvider,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "about-us-client",
            name: "AboutUsClient",
            component: AboutUsClient,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "about-us-driver",
            name: "AboutUsDriver",
            component: AboutUsDriver,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "about-us-provider",
            name: "AboutUsProvider",
            component: AboutUsProvider,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "terms-client",
            name: "TermsClient",
            component: TermsClient,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
           {
            path: "terms-provider",
            name: "TermsProvider",
            component: TermsProvider,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
           {
            path: "terms-driver",
            name: "TermsDriver",
            component: TermsDriver,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "policy-client",
            name: "PrivacyPolicyClient",
            component: PrivacyPolicyClient,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
            {
            path: "policy-provider",
            name: "PrivacyPolicyProvider",
            component: PrivacyPolicyProvider,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          }, 
          {
            path: "policy-driver",
            name: "PrivacyPolicyDriver",
            component: PrivacyPolicyDriver,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
            {
            path: "delete-account",
            name: "DeleteAccount",
            component: DeleteAccount,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
        
        ],
      },
      // End:: App Content Routes Config

      // Start:: AllFinancialOrders Routes Config
      // {
      //   path: "/financialorders",
      //   name: "FinancialOrdersHome",
      //   component: FinancialOrdersHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "AllFinancialOrders",
      //       component: AllFinancialOrders,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "roles index",
      //           subject: "roles",
      //         },
      //       },
      //     },
      //   ],
      // },
      // {
      //   path: "/financialpack",
      //   name: "FinancialPackHome",
      //   component: FinancialPackHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "AllFinancialPack",
      //       component: AllFinancialPack,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "roles index",
      //           subject: "roles",
      //         },
      //       },
      //     },
      //   ],
      // },

      // Start:: Financial Reports Routes Config
      // {
      //   path: "/financial-reports",
      //   name: "FinancialReportsHome",
      //   component: FinancialReportsHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "AllFinancialReports",
      //       component: AllFinancialReports,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "financial_reports unfinishedordersreports",
      //           subject: "financial_reports",
      //         },
      //       },
      //     },
      //   ],
      // },

      // {
      //   path: "/financial-finished-reports",
      //   name: "FinancialFinshedReportsHome",
      //   component: FinancialFinshedReportsHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "AllFinancialFinshedReports",
      //       component: AllFinancialFinshedReports,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "financial_reports finishedordersreports",
      //           subject: "financial_reports",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: Financial Reports Routes Config

      // Start:: Roles Routes Config
      {
        path: "/roles",
        name: "RolesHome",
        component: RolesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllRoles",
            component: AllRoles,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "roles index",
                subject: "roles",
              },
            },
          },
          {
            path: "create",
            name: "CreateRole",
            component: CreateRole,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "roles create",
                subject: "roles",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditRole",
            component: EditRole,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "roles edit",
                subject: "roles",
              },
            },
          },
        ],
      },
      // End:: Roles Routes Config

      // Start:: Admins Routes Config
      {
        path: "/admins",
        name: "AdminsHome",
        component: AdminsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllAdmins",
            component: AllAdmins,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "users index",
                subject: "users",
              },
            },
          },
          {
            path: "create",
            name: "CreateAdmin",
            component: CreateAdmin,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "users create",
                subject: "users",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditAdmin",
            component: EditAdmin,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "users edit",
                subject: "users",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowAdmin",
            component: ShowAdmin,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "users show",
                subject: "users",
              },
            },
          },
        ],
      },
      // End:: Admins Routes Config

      // Start:: users Routes Config
      {
        path: "/users",
        name: "UsersHome",
        component: UsersHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllUsers",
            component: AllUsers,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "users index",
                subject: "users",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowUsers",
            component: ShowUsers,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "users show",
                subject: "users",
              },
            },
          },
        ],
      },
      // End:: users Routes Config
      // Start:: FinancialFinshedOrders Routes Config
      {
        path: "/finished-orders",
        name: "FinancialFinishedOrdersHome",
        component: FinancialFinishedOrdersHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllFinancialFinishedOrders",
            component: AllFinancialFinishedOrders,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "reports index",
                subject: "reports",
              },
            },
          },
        ],
      },
      // End:: FinancialUnFinshedOrders Routes Config
       // Start:: FinancialUnFinshedOrders Routes Config
      {
        path: "/unfinished-orders",
        name: "FinancialUnFinishedOrdersHome",
        component: FinancialUnFinishedOrdersHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllFinancialUnFinishedOrders",
            component: AllFinancialUnFinishedOrders,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "reports index",
                subject: "reports",
              },
            },
          },
        ],
      },
      // End:: FinancialUnFinshedOrders Routes Config

      // Start:: products  Config
      {
        path: "/products",
        name: "products",
        component: ProductsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allproducts",
            component: AllProducts,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "products index",
                subject: "products",
              },
            },
          },
          {
            path: "create",
            name: "Createproducts",
            component: CreateProducts,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "products create",
                subject: "products",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editproducts",
            component: EditProducts,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "products edit",
                subject: "products",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showproducts",
            component: ShowProducts,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "products show",
                subject: "products",
              },
            },
          },
        ],
      },
      // End:: products Config

      // Start:: orders  Config
      {
        path: "/orders",
        name: "orders",
        component: ordersHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allorders",
            component: Allorders,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "orders index",
                subject: "orders",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showorders",
            component: Showorders,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "orders show",
                subject: "orders",
              },
            },
          },
        ],
      },
      // End:: orders Config

      // Start:: cities  Config
      {
        path: "/states",
        name: "states",
        component: StatesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllStates",
            component: AllStates,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "states index",
                subject: "states",
              },
            },
          },
          {
            path: "create",
            name: "CreateStates",
            component: CreateStates,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "states create",
                subject: "states",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditStates",
            component: EditStates,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "states edit",
                subject: "states",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowStates",
            component: ShowStates,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "states show",
                subject: "States",
              },
            },
          },
        ],
      },
      // End:: States Config

      // Start:: districts  Config
      {
        path: "/districts",
        name: "districts",
        component: DistrictsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Alldistricts",
            component: AllDistricts,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "districts index",
                subject: "districts",
              },
            },
          },
          {
            path: "create",
            name: "Createdistricts",
            component: CreateDistricts,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "districts create",
                subject: "districts",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editdistricts",
            component: EditDistricts,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "districts edit",
                subject: "districts",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showdistricts",
            component: ShowDistricts,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "districts show",
                subject: "districts",
              },
            },
          },
        ],
      },
      // End:: districts Config

      // Start:: RegionsHome  Config
      {
        path: "/regions",
        name: "regions",
        component: RegionsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllRegions",
            component: AllRegions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "regions index",
                subject: "regions",
              },
            },
          },
          {
            path: "create",
            name: "CreateRegions",
            component: CreateRegions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "regions create",
                subject: "regions",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditRegions",
            component: EditRegions,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "regions edit",
                subject: "regions",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowRegions",
            component: ShowRegions,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "regions show",
                subject: "regions",
              },
            },
          },
        ],
      },
      // End:: Regions Config

      // Start:: services  Config
      {
        path: "/services",
        name: "services",
        component: ServicesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allservices",
            component: AllServices,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "services index",
                subject: "services",
              },
            },
          },
          {
            path: "create",
            name: "Createservices",
            component: CreateServices,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "services create",
                subject: "services",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editservices",
            component: EditServices,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "services edit",
                subject: "services",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showservices",
            component: ShowServices,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "services show",
                subject: "services",
              },
            },
          },
        ],
      },
      // End:: services Config

      // Start:: Sizes  Config
      {
        path: "/sizes",
        name: "Sizes",
        component: SizesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllSizes",
            component: AllSizes,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "sizes index",
                subject: "sizes",
              },
            },
          },
          {
            path: "create",
            name: "CreateSizes",
            component: CreateSizes,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "sizes create",
                subject: "sizes",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditSizes",
            component: EditSizes,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "sizes edit",
                subject: "sizes",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowSizes",
            component: ShowSizes,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "sizes show",
                subject: "sizes",
              },
            },
          },
        ],
      },
      // End:: Sizes Config

      // Start:: Additions  Config
      {
        path: "/additions",
        name: "Additions",
        component: AdditionsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllAdditions",
            component: AllAdditions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "additions index",
                subject: "additions",
              },
            },
          },
          {
            path: "create",
            name: "CreateAdditions",
            component: CreateAdditions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "additions create",
                subject: "additions",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditAdditions",
            component: EditAdditions,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "additions edit",
                subject: "additions",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowAdditions",
            component: ShowAdditions,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "additions show",
                subject: "additions",
              },
            },
          },
        ],
      },
      // End:: Additions Config
      // Start:: CardsCategories  Config
      {
        path: "/cardscategories",
        name: "CardsCategories",
        component: CardsCategoriesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllCardsCategories",
            component: AllCardsCategories,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "cardcategories index",
                subject: "cardcategories",
              },
            },
          },
          {
            path: "create",
            name: "CreateCardsCategories",
            component: CreateCardsCategories,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "cardcategories create",
                subject: "cardcategories",
              },
            },
          },

          {
            path: "show/:id",
            name: "ShowCardsCategories",
            component: ShowCardsCategories,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "cardcategories show",
                subject: "cardcategories",
              },
            },
          },
        ],
      },
      // End:: CardsCategories Config
      // Start:: CardsCategories  Config
      {
        path: "/cards",
        name: "cards",
        component: CardsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllCards",
            component: AllCards,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "cards index",
                subject: "cards",
              },
            },
          },
        ],
      },
      // End:: Cards Config

      // Start:: Offers  Config
      {
        path: "/offers",
        name: "offers",
        component: OffersHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllOffers",
            component: AllOffers,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "offers index",
                subject: "offers",
              },
            },
          },
          {
            path: "create",
            name: "CreateOffers",
            component: CreateOffers,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "offers create",
                subject: "offers",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditOffers",
            component: EditOffers,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "offers edit",
                subject: "offers",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowOffers",
            component: ShowOffers,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "offers show",
                subject: "offers",
              },
            },
          },
        ],
      },
      // End:: Offers Config

      // Start:: workplaces  Config
      {
        path: "/workplaces",
        name: "workplaces",
        component: WorkplacesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allworkplaces",
            component: AllWorkplaces,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "workplaces index",
                subject: "workplaces",
              },
            },
          },
          {
            path: "create",
            name: "Createworkplaces",
            component: CreateWorkplaces,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "workplaces create",
                subject: "workplaces",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editworkplaces",
            component: EditWorkplaces,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "workplaces edit",
                subject: "workplaces",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showworkplaces",
            component: ShowWorkplaces,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "workplaces show",
                subject: "workplaces",
              },
            },
          },
        ],
      },
      // End:: workplaces Config

      // Start:: WalletRequests  Config
      {
        path: "/request-wallets",
        name: "RequestWallets",
        component: RequestWalletsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllRequestWallets",
            component: AllRequestWallets,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "withdraw_requests index",
                subject: "withdraw_requests",
              },
            },
          },
        ],
      },
      // End:: WalletRequests Config

      // start::designers orders
      {
        path: "/users-requests",
        name: "UserRequestsHome",
        component: UserRequestsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllUserRequests",
            component: AllUserRequests,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "acceptedproviders index",
                subject: "acceptedproviders",
              },
            },
          },

          {
            path: "show/:id",
            name: "ShowUserRequests",
            component: ShowUserRequests,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "acceptedproviders show",
                subject: "acceptedproviders",
              },
            },
          },
        ],
      },
      // End::designers orders
      // start::designers orders
      {
        path: "/driver-requests",
        name: "DriverRequestsHome",
        component: DriverRequestsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllDriverRequests",
            component: AllDriverRequests,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "driverjoinrequests index",
                subject: "driverjoinrequests",
              },
            },
          },

          {
            path: "show/:id",
            name: "ShowDriverRequests",
            component: ShowDriverRequests,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "driverjoinrequests show",
                subject: "driverjoinrequests",
              },
            },
          },
          {
            path: "driver-wallet",
            name: "WalletDriver",
            component: WalletDriver,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "installments index",
                subject: "installments",
              },
            },
          },
        ],
      },

      {
        path: "/driver-update",
        name: "DriverUpdateHome",
        component: DriverUpdateHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllDriverUpdate",
            component: AllDriverUpdate,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "driverjoinrequestmodifications index",
                subject: "driverjoinrequestmodifications",
              },
            },
          },

          {
            path: "show/:id",
            name: "ShowDriverUpdate",
            component: ShowDriverUpdate,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "driverjoinrequestmodifications show",
                subject: "driverjoinrequestmodifications",
              },
            },
          },
        ],
      },
      {
        path: "/driver-manegment",
        name: "DriverManegmentHome",
        component: DriverManegmentHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllDriverManegment",
            component: AllDriverManegment,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "drivers index",
                subject: "drivers",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditDriverManegment",
            component: EditDriverManegment,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "drivers index",
                subject: "drivers",
              },
            },
          },

          {
            path: "show/:id",
            name: "ShowDriverManegment",
            component: ShowDriverManegment,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "drivers show",
                subject: "drivers",
              },
            },
          },
        ],
      },

      // asssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssss

      {
        path: "/admins-requests",
        name: "AdminsRequestsHome",
        component: AdminsRequestsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllAdminsRequests",
            component: AllAdminsRequests,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "providers index",
                subject: "providers",
              },
            },
          },

          {
            path: "show/:id",
            name: "ShowAdminsRequests",
            component: ShowAdminsRequests,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "acceptedproviders show",
                subject: "acceptedproviders",
              },
            },
          },
          {
            path: "provider-wallet",
            name: "WalletProvider",
            component: WalletProvider,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "installments index",
                subject: "installments",
              },
            },
          },
        ],
      },

      {
        path: "/admins-update",
        name: "AdminsUpdateHome",
        component: AdminsUpdateHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllAdminsUpdate",
            component: AllAdminsUpdate,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "providerjoinrequestmodifications index",
                subject: "providerjoinrequestmodifications",
              },
            },
          },

          {
            path: "show/:id",
            name: "ShowAdminsUpdate",
            component: ShowAdminsUpdate,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "providerjoinrequestmodifications show",
                subject: "providerjoinrequestmodifications",
              },
            },
          },
        ],
      },
      {
        path: "/providers",
        name: "ProviderHome",
        component: ProviderHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllProviders",
            component: AllProviders,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "providers index",
                subject: "providers",
              },
            },
          },

          {
            path: "show/:id",
            name: "ShowProviders",
            component: ShowProviders,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "providers show",
                subject: "providers",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditProviders",
            component: EditProviders,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "providers edit",
                subject: "providers",
              },
            },
          },
          {
            path: "edit/workingHours/:id",
            name: "WorkingHoursProviders",
            component: WorkingHoursProviders,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "providers edit",
                subject: "providers",
              },
            },
          },
        ],
      },
      // End::designers orders

      // Start:: WalletHistory  Config
      {
        path: "/WalletHistory",
        name: "WalletHistory",
        component: WalletHistoryHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all/:id",
            name: "AllWalletHistory",
            component: AllWalletHistory,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "users index",
                subject: "users",
              },
            },
          },
        ],
      },
      // End:: WalletHistory Config

      // Start:: Providers  Config
      // {
      //   path: "/providers",
      //   name: "Providers",
      //   component: ProvidersHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "AllProviders",
      //       component: AllProviders,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "providers index",
      //           subject: "providers",
      //         },
      //       },
      //     },
      //     {
      //       path: "create",
      //       name: "CreateProviders",
      //       component: CreateProviders,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "providers create",
      //           subject: "providers",
      //         },
      //       },
      //     },
      //     {
      //       path: "edit/:id",
      //       name: "EditProviders",
      //       component: EditProviders,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "providers edit",
      //           subject: "providers",
      //         },
      //       },
      //     },
      //     {
      //       path: "show/:id",
      //       name: "ShowProviders",
      //       component: ShowProviders,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "providers show",
      //           subject: "providers",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: Providers Config

      // Start:: banks  Config
      {
        path: "/banks",
        name: "banks",
        component: BanksHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allbanks",
            component: AllBanks,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "banks index",
                subject: "banks",
              },
            },
          },
          {
            path: "create",
            name: "Createbanks",
            component: CreateBanks,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "banks create",
                subject: "banks",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editbanks",
            component: EditBanks,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "banks edit",
                subject: "banks",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showbanks",
            component: ShowBanks,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "banks show",
                subject: "banks",
              },
            },
          },
        ],
      },
      // End:: banks Config

      // Start:: packages  Config
      {
        path: "/packages",
        name: "packages",
        component: PackagesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allpackages",
            component: AllPackages,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "packages index",
                subject: "packages",
              },
            },
          },
          {
            path: "create",
            name: "Createpackages",
            component: CreatePackages,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "packages create",
                subject: "packages",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editpackages",
            component: EditPackages,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "packages edit",
                subject: "packages",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showpackages",
            component: ShowPackages,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "packages show",
                subject: "packages",
              },
            },
          },
        ],
      },
      // End:: packages Config

      // Start:: ads  Config
      {
        path: "/ads",
        name: "ads",
        component: AdsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllAds",
            component: AllAds,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "sliders index",
                subject: "sliders",
              },
            },
          },
          {
            path: "create",
            name: "CreateAds",
            component: CreateAds,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "sliders create",
                subject: "sliders",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditAds",
            component: EditAds,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "sliders edit",
                subject: "sliders",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowAds",
            component: ShowAds,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "sliders show",
                subject: "sliders",
              },
            },
          },
        ],
      },
      // End:: ads Config

      // Start:: All Notifications Route Config
      {
        path: "/all-notifications",
        name: "NotificationsHome",
        component: NotificationsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllNotifications",
            component: AllNotifications,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "notifications index",
                subject: "notifications",
              },
            },
          },
          {
            path: "create",
            name: "CreateNotificationss",
            component: CreateNotifications,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "notifications create",
                subject: "notifications",
              },
            },
          },
          {
            path: "show",
            name: "ShowAllNotifications",
            component: ShowAllNotifications,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "notifications index",
                subject: "notifications",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowNotificationss",
            component: ShowNotificationsTable,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "notifications index",
                subject: "notifications",
              },
            },
          },
        ],
      },
      // End:: All Notifications Route Config

      // Start:: Clients Routes Config
      {
        path: "/Clients",
        name: "ClientsHome",
        component: ClientsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllClients",
            component: AllClients,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "clients index",
                subject: "clients",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowClients",
            component: ShowClients,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "clients show",
                subject: "clients",
              },
            },
          },
        ],
      },
      // End:: Clients Routes Config

      // Start:: Order requests config
      {
        path: "/order-requests",
        name: "OrdersRequestsHome",
        component: OrdersRequestsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllOrdersRequests",
            component: AllOrdersRequests,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "users index",
                subject: "users",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowOrdersRequests",
            component: ShowOrdersRequests,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "users index",
                subject: "users",
              },
            },
          },
        ],
      },
      // End:: Order requests config

      // Start:: questions Routes Config
      {
        path: "/questions",
        name: "questionsHome",
        component: questionsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allquestions",
            component: Allquestions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "questions index",
                subject: "questions",
              },
            },
          },
          {
            path: "create",
            name: "Createquestions",
            component: Createquestions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "questions create",
                subject: "questions",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editquestions",
            component: Editquestions,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "questions edit",
                subject: "questions",
              },
            },
          },
        ],
      },
      // End:: questions Routes Config

      // Start:: Product Categories Routes Config
      {
        path: "/product-categories",
        name: "ProductCategoriesHome",
        component: ProductCategoriesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllProductCategories",
            component: AllProductCategories,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "categories index",
                subject: "categories",
              },
            },
          },
          {
            path: "create",
            name: "CreateProductCategories",
            component: CreateProductCategories,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "categories create",
                subject: "categories",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditProductCategories",
            component: EditProductCategories,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "categories edit",
                subject: "categories",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowProductCategories",
            component: ShowProductCategories,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "categories show",
                subject: "categories",
              },
            },
          },
        ],
      },
      // End:: Product Categories Routes Config

      // Start:: Categories Routes Config
      {
        path: "/main-categories",
        name: "CategoriesHome",
        component: CategoriesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllCategories",
            component: AllCategories,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "sections index",
                subject: "sections",
              },
            },
          },
          {
            path: "create",
            name: "CreateCategories",
            component: CreateCategories,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "sections create",
                subject: "sections",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditCategories",
            component: EditCategories,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "sections edit",
                subject: "sections",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowCategories",
            component: ShowCategories,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "sections show",
                subject: "sections",
              },
            },
          },
        ],
      },
      // End:: Categories Routes Config

      // Start:: app-rates Routes Config
      {
        path: "/app-rate",
        name: "AppRatesHome",
        component: AppRatesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllAppRates",
            component: AllAppRates,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "rates index",
                subject: "rates",
              },
            },
          },
        ],
      },
      // End:: app-rates Routes Config

      // Start:: app-rates Routes Config
      {
        path: "/store-rate",
        name: "StoreRatesHome",
        component: StoreRatesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllStoreRates",
            component: AllStoreRates,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "rates index",
                subject: "rates",
              },
            },
          },
        ],
      },
      // End:: app-rates Routes Config

      // Start:: sub Categories Routes Config
      {
        path: "/sub-categories",
        name: "CategoriesHome",
        component: SubCategoriesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllSubCategories",
            component: AllSubCategories,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "subcategories index",
                subject: "subcategories",
              },
            },
          },
          {
            path: "create",
            name: "CreateSubCategories",
            component: CreateSubCategories,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "subcategories index",
                subject: "subcategories",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditSubCategories",
            component: EditSubCategories,
            props: true,
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "show/:id",
            name: "ShowSubCategories",
            component: ShowSubCategories,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "subcategories index",
                subject: "subcategories",
              },
            },
          },
        ],
      },
      // End:: sub Categories Routes Config

      // Start:: management Routes Config
      {
        path: "/managements",
        name: "ManagementsHome",
        component: ManagementsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllManagements",
            component: AllManagements,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "management index",
                subject: "management",
              },
            },
          },
          {
            path: "create",
            name: "CreateManagements",
            component: CreateManagements,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "management index",
                subject: "management",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditManagements",
            component: EditManagements,
            props: true,
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "show/:id",
            name: "ShowManagements",
            component: ShowManagements,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "management index",
                subject: "management",
              },
            },
          },
        ],
      },
      // End:: management Routes Config

      // Start:: Capacities  Config
      {
        path: "/Capacities",
        name: "CapacitiesHome",
        component: CapacitiesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllCapacitiesHome",
            component: AllCapacities,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "capacities index",
                subject: "capacities",
              },
            },
          },
          {
            path: "create",
            name: "CreateCapacities",
            component: CreateCapacities,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "capacities create",
                subject: "capacities",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditCapacities",
            component: EditCapacities,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "capacities edit",
                subject: "capacities",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowCapacities",
            component: ShowCapacities,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "capacities show",
                subject: "capacities",
              },
            },
          },
        ],
      },
      // End:: Capacities Config

      // Start:: App contact Routes Config
      {
        path: "/contact_settings",
        component: GeneralSettings,
        meta: {
          middleware: [auth],
          requiresPermission: {
            action: "settings create",
            subject: "settings",
          },
        },
      },
      {
        path: "/app_settings",
        component: AppSettings,
        meta: {
          middleware: [auth],
          requiresPermission: {
            action: "settings edit",
            subject: "settings",
          },
        },
      },
      // End:: App contact Routes Config
    ],
  },
  // ***************** End:: Content Routes Config

  // ***************** Start:: Forbidden Route Config
  {
    path: "/forbidden",
    name: "ForbiddenPage",
    component: ForbiddenPage,
  },
  // ***************** End:: Forbidden Route Config

  // ***************** Start:: Not Found Route Config
  {
    path: "/:notFound(.*)",
    name: "NotFoundPage",
    component: NotFoundPage,
  },
  // ***************** End:: Not Found Route Config
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to) {
    document.getElementById("app").scrollIntoView({ behavior: "smooth" });
    if (to.hash) {
      return {
        selector: to.hash,
      };
    }
  },
  routes,
});

// Start:: Middleware And Router Guards
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    context.next(...parameters);
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

// Authentication and Permission Check Middleware
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem("modo_dashboard_user_token");

  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];
    const context = { from, next, router, to };
    const nextMiddleware = nextFactory(context, middleware, 1);
    return middleware[0]({ ...context, next: nextMiddleware });
  } else if (isAuthenticated) {
    const publicRoutes = [
      "LoginForm",
      "ResetPasswordEmailForm",
      "PhoneVerification",
      "ChangePhoneNumberForm",
      "ResetPasswordForm",
    ];

    if (publicRoutes.includes(to.name)) {
      return next("/home");
    }
  }

  if (to.meta.requiresPermission) {
    const { action, subject } = to.meta.requiresPermission;
    const storedPermissions = JSON.parse(
      localStorage.getItem("modo_roles")
    )?.permissions;

    if (
      storedPermissions &&
      storedPermissions.some(
        (permission) =>
          permission.action === action && permission.subject === subject
      )
    ) {
      return next();
    } else {
      return next("/forbidden");
    }
  }

  return next();
});

export default router;
